import { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { urlsfilterdinterface } from "../../../configurations/Helpers/Dateshelper";
import { todayFilters, monthFilters, yearsFilters } from "../../../configurations/Helpers/Dateshelper";
import { useLocation } from "react-router-dom";

export interface SpecificFilter {
  url: string;
  type: string;
}

interface AdministrationPanelContextType {
  urlsfiltered: urlsfilterdinterface;
  filter: string;
  setFilter: (filter: string) => void;
  setSpecificFilter: (specificFilter: SpecificFilter) => void;
  TableID: string;
  viewFilters: () => boolean;
}

const AdministrationPanelContext = createContext<AdministrationPanelContextType | undefined>(undefined);

export const AdministrationPanelProvider = ({ children }: { children: ReactNode }) => {
  const [filter, setFilter] = useState<string>("today");
  const [specificFilter, setSpecificFilter] = useState<SpecificFilter>({ url: "", type: "" });
  const [urlsfiltered, setUrlsfiltered] = useState<urlsfilterdinterface>(todayFilters());
  const [TableID, setTableId] = useState("Horas");
  const location = useLocation();



  useEffect(() => {

    switch (filter) {
      case "today":
        setTableId("Hora");
        setUrlsfiltered(todayFilters());
        break;
      case "month":
        setTableId("Dia");
        setUrlsfiltered(monthFilters());
        break;
      case "year":
        setTableId("Mes");
        setUrlsfiltered(yearsFilters());
        break;
      default:

        break;
    }
  }, [filter])



  useEffect(() => {
    if (specificFilter.url) {
      const urls = {
        onlydates: specificFilter.url,
        withtimefilter: specificFilter.url + "&filter=" + specificFilter.type,
        withterminalfilter: specificFilter.url + "&Terminals=1",
        onlydatesintermedial: specificFilter.url.replace('?', '&'),
        withParameter: specificFilter.url + "&parameter=day"
      }
      setUrlsfiltered(urls);
      if (specificFilter == null) return;
      if (specificFilter.type.includes("H")) setTableId("Hora");
      if (specificFilter.type.includes("D")) setTableId("Dia");
      if (specificFilter.type.includes("M")) setTableId("Mes");
      if (specificFilter.type.includes("Y")) setTableId("Año");

    }
  }, [specificFilter])

  const viewFilters = () => {

    if (location.pathname === "/AdministrationPanel/Users" ||
      location.pathname === "/AdministrationPanel/DailyManagement/ScheduleControl" ||
      location.pathname === "/AdministrationPanel/DailyManagement/TeamsControl" ||
      location.pathname==="/AdministrationPanel/Inventory" ||
      location.pathname==="/AdministrationPanel/Analytics/LogViewer" ||
      location.pathname === "/AdministrationPanel/Configurations/*")
      return false;
    return true;
  }

  return (
    <AdministrationPanelContext.Provider value={{ urlsfiltered, filter, setFilter, setSpecificFilter, TableID, viewFilters }}>
      {children}
    </AdministrationPanelContext.Provider>
  );
};

export const useAdministrationPanel = (): AdministrationPanelContextType => {
  const context = useContext(AdministrationPanelContext);
  if (!context) {
    throw new Error("useAdministrationPanel must be used within an AdministrationPanelProvider");
  }
  return context;
};
